import React from 'react';

const screenshots = [1, 2, 3, 4, 5, 6, 7];

const ScreenshotsSection: React.FC = () => {
  return (
    <section className="px-6 py-14 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <p className="text-indigo-600 text-xs font-semibold uppercase tracking-widest mb-2">App Preview</p>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">See Sahayy in Action</h2>
          <p className="text-gray-500 mt-2">Discover how Sahayy brings your community together</p>
        </div>
        <div className="flex gap-4 overflow-x-auto pb-2">
          {screenshots.map(id => (
            <div key={id} className="rounded-2xl border border-indigo-100 shrink-0 w-48 overflow-hidden shadow-sm">
              <img
                src={`/screenshots/image${id}.png`}
                alt={`Sahayy App Screenshot ${id}`}
                className="w-full h-auto"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScreenshotsSection;
